<template>
  <b-card>
    <b-overlay :show="loading" no-wrap></b-overlay>
    <b-form @submit.prevent="saveAdjustment">
      <b-row class="align-items-end">
        <b-col cols="12" lg="6">
          <b-form-group label="Razón del ajuste">
            <b-form-select v-model="form.reasonId" :options="reasonOptions"></b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" lg="6">
          <b-form-group label="Tarifa a pagar">
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>$</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                v-model.number="form.amount"
                type="number"
                step="0.01"
                placeholder="Ingrese monto"
              ></b-form-input>
              <b-input-group-append>
                <b-input-group-text>{{currency}}</b-input-group-text>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

       
       
      </b-row>
      <b-row class="justify-content-end">
        <b-col cols="12" lg="auto">
          <b-button variant="outline-danger" @click="clearFields" class="mr-2">Limpiar</b-button>
          <b-button type="submit" variant="success">Guardar</b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
export default {
  props: {
    transportServiceId: { 
      required: true 
    },
  },
  data() {
    return {
      loading:false,
      currency:"",
      form: {
        amount: null, 
        reasonId: null
      },
    };
  },
  computed: {
    reasonOptions() {
      const options = this.$root.auxVars.reasonStatesSupplierRemmitanceOpts.map(item => ({
        value: item.id,
        text: item.label,
      }));
      options.unshift({ value: null, text: "Select a reason" });
      return options;
    },
  },
  watch: {
    transportServiceId: {
      handler(newId) {
        if (newId) {
          this.fetchAdjustmentData(newId);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async fetchAdjustmentData(serviceId) {
      try {
        const response = await this.$root.api.get(`/transport-service/${serviceId}/supplier-remittance/`);
        if (response.data) {
          this.form.amount = (response.data.settings.amount !== undefined) ? response.data.settings.amount : null; // Ensures null if no value
          this.form.reasonId = response.data.settings.reasonId || null;
          this.currency = response.data.settings.currency
        }
      } catch (error) {
        console.error("Error fetching adjustment data:", error);
      }
    },
    async saveAdjustment() {
      try {
        this.loading= true;
        const response = await this.$root.api.post(`/transport-service/${this.transportServiceId}/supplier-remittance`, {
            amount: this.form.amount,
            reasonId: this.form.reasonId,
        });
        this.loading= false;

        this.$root.showAlert("Se actualizó correctamente", {
					variant: "success"
				});

  
        if (response.data) {
          this.form.amount = (response.data.settings.amount !== undefined) ? response.data.settings.amount : null;
          this.form.reasonId = response.data.settings.reasonId || null;
          this.currency      = response.data.settings.currency || ''; 
        }
      } catch (error) {
        this.loading= false;
        console.error("Error saving adjustment:", error);
        const errorMessage = error.response?.data?.message || "Ocurrió un error inesperado";
        this.$root.showAlert(errorMessage, { variant: "error" });
      }
    },
    clearFields() {
      this.form.amount = null;
      this.form.reasonId = null;
    },
  },
  mounted() {
    this.$root.auxVars.loadResourcesOpts({ vm: this, resourceNames: ["reasonStatesSupplierRemmitanceOpts"] });
  },
};
</script>
